module.exports = __webpack_public_path__ + "static/media/loader.e4d9a04b.gif";